import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {ENTITY_ID_DESIGNATION} from "../generic/Constants";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {DMSDateColumnFormatter} from "../../column-formatters/DMSDateColumnFormatter";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {DesignationAddEditDialog} from "./DesignationAddEditDialog";

export function DesignationsPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const columns = [
        {
            dataField: "id",
            text: "Id",
            hidden: true
        }, {
            dataField: "name",
            text: "Designation Name",
            formatter: HeaderColumnFormatter,
            search: true
        },
        {
            dataField: "createdOn",
            text: "Created On",
            formatter: DMSDateColumnFormatter,
            showInMobile: false,
        },
        {
            dataField: "updatedOn",
            text: "Updated On",
            formatter: DMSDateColumnFormatter,
            showInMobile: false,
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal(true);
    }

    function reloadData() {
        setReload(reload + 1);
    }

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete the Designation? You will be able to delete it only if it is not used anywhere.");
        if (result) {
            genericDelete(ENTITY_ID_DESIGNATION, row.id).then(() => {
                showToast("Designation is Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
                }
            ).finally(() => {
                reloadData();
            });
        }
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = () => setShowModal(false);

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "ADD DESIGNATION",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Designations</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_DESIGNATION}
                    />
                )}
            </div>
            <DesignationAddEditDialog show={showModal} handleClose={handleClose} id={showModelId} onSave={reloadData}/>
        </>
    );
}
